import { createSignal, onCleanup, onMount } from 'solid-js';

export const useNetworkStatus = () => {
  const [online, setOnline] = createSignal<boolean>(
    typeof navigator === 'undefined' ? true : navigator.onLine,
  );
  const [lastOnlineAt, setLastOnlineAt] = createSignal<number>(Date.now());

  onMount(() => {
    const onOnline = () => {
      setOnline(true);
      setLastOnlineAt(Date.now());
    };
    const onOffline = () => setOnline(false);
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    onCleanup(() => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    });
  });

  return { online, lastOnlineAt };
};
